import tempSessionIdGetter from '~/utils/deviceId.js';

const getCredentials = (captchaToken, authentication) => {
	const { email, password, isComplianceTermsAccepted = false } = authentication;

	const deviceId = tempSessionIdGetter();

	const credentials = {
		email,
		password,
		captchaToken, // : captchaToken || captchaTokenResponse,
		isComplianceTermsAccepted,
		deviceId
	};

	return credentials;
};

export default getCredentials;
